import {openConfirmDialog, useDialogCloseGuard} from 'platform/components';

import {useRef} from 'react';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface UnsavedMessageCloseGuardProps extends RequiredTestIdProps {
  /** Read when the dialog is about to close, so it sees the values typed last. */
  hasUnsavedChanges: () => boolean;
}

/**
 * Asks before the dialog it sits in closes over a message the employee has written. A second
 * Escape out of habit used to throw away the whole e-mail, AI draft included (seen in review).
 */
export function UnsavedMessageCloseGuard(props: UnsavedMessageCloseGuardProps) {
  const isConfirmOpenRef = useRef(false);

  useDialogCloseGuard((close) => {
    // Escape pressed on the confirm reaches this dialog as well; the confirm answers it.
    if (isConfirmOpenRef.current) {
      return true;
    }
    if (!props.hasUnsavedChanges()) {
      return false;
    }

    isConfirmOpenRef.current = true;
    openConfirmDialog({
      text: i18n.t('general.notifications.unsavedChanges.description'),
      onConfirm: close,
      onCloseComplete: () => {
        isConfirmOpenRef.current = false;
      },
      'data-testid': suffixTestId('unsavedChanges', props),
    });
    return true;
  });

  return null;
}
